import { APIPersonalAutoApplicationForm, APISpouse } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processMaritalStatusData = (
  applicationData: APIPersonalAutoApplicationForm,
  validation?: Validation,
): BinderSectionData => {
  const drivers = applicationData?.drivers || [];
  const unlistedSpouses = applicationData?.unlisted_spouses || [];

  // Create table rows combining driver and spouse information
  const driverRows = drivers.map((driver, index: number) => {
    const isValid = validateFailedObjects(index, validation);

    const spouse: APISpouse =
      unlistedSpouses.find(
        (spouse: APISpouse) => driver.marital_status === 'M',
      ) || ({} as APISpouse);

    return {
      number: index + 1,
      driverName: driver?.name || '',
      maritalStatus: driver?.marital_status || '',
      spouseName: spouse?.name || '',
      spouseLicenseNumber: spouse?.license_number || '',
      spouseCompany: spouse?.carrier || '',
      spousePolicyNumber: spouse?.policy || '',
      spouseExpiryDate: spouse?.expiry_date || '',
      hasMaritalStatus: !!driver?.marital_status,
      isValid,
    };
  });

  const validationData = processValidation(validation);

  return {
    title: 'Marital status',
    description: 'Check to account for any spouses not listed on application.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      driverRows,
    },
  };
};
